import { SessionStore } from './session.store';
import _ from 'lodash';
import { IViewNavigator } from '@dirootie-web/web-apps-types';
import { UserProfile } from './user-profile';
import { RoleType } from './iam.types';


export class AuthorizationService {
  public static inject = ['sessionStore', 'viewNavigator'] as const;
  private _isAuthorized: boolean = false;
  constructor(
    private sessionStore: SessionStore,
    private viewNavigator: IViewNavigator
  ) {}
  getStartPageForRole(role: any): string {
    if (role === 'Admin') {
      return '/management';
    }
    if (role === 'Lecturer') {
      return '/lecturers';
    }
    if (role === 'Student') {
      return '/students';
    }
    return '/errors/not-found';
  }

  handleActiveAccount(profile: UserProfile, from?: string) {
    this.handleInvitedAccount(profile, from);
  }
  handleInvitedAccount(profile: UserProfile, from?: string) {
    this.sessionStore.setUserProfile(profile);
    this._isAuthorized = true;
    if (from === undefined) {
      this.navigateToRoleHomePage(profile.role);
    }
  }

  handleBlockedAccount(profile: UserProfile) {
    this.sessionStore.setUserProfile(profile);
    this._isAuthorized = false;
    this.viewNavigator.navigateToPath('/errors/blocked-account');
  }

  handleNonExistingAccount(profile: UserProfile) {
    this._isAuthorized = false;
    if (!this.viewNavigator.isLogoutRoute()) {
      this.viewNavigator.navigateToPath('/errors/no-account');
    }
  }

  handleAccountError(): Promise<void> {
    this._isAuthorized = false;
    this.viewNavigator.navigateToPath('/errors/internal-server-error');
    return Promise.reject();
  }

  navigateToRoleHomePage(role: RoleType) {
    const home = this.getStartPageForRole(role);
    this.viewNavigator.navigateToPath(home);
  }

  hasPermission(roles: RoleType[]) {
    return (
      roles.findIndex((x) => x === this.sessionStore.userProfile?.role!) > -1
    );
  }

  isAuthorized() {
    return this._isAuthorized;
  }
}
